/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CustomButton from 'src/common/components/CustomButton';
import PageLayout from 'src/common/components/PageLayout';
import AdviserUserTab from './components/AdviserUserTab';
import AntTabs from 'src/common/components/AntTabs';
import LinkUserTab from './components/LinkUserTab';
import notice from 'src/common/components/Notice';
import { Grid, makeStyles } from '@material-ui/core';
import { userTypeTabs, buttonsUser, defaultUser, defaultOrgans } from './utils/list_data';
import { usersAPI } from 'src/api/modules/users';
import { useSelector } from 'react-redux';

const useStyles = makeStyles({
	containerButtons: {
		marginTop: 20,
		width: '100%',
		margin: 0,
	},
	subContainerButtons: {
		flexDirection: 'row',
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'flex-end',
	},
});

const NewUser = () => {
	const { id, perfil } = useParams();
	const [userResp, setUser] = useState(defaultUser);
	const [member, setMember] = useState({ member: false });
	const [memberOriginal, setMemberOriginal] = useState(false);
	const [flagOrgans, setFlagOrgans] = useState([]);
	const [addOrgans, setAddOrgans] = useState(defaultOrgans);
	const [idOrgans, setIdOrgans] = useState();
	const [tabValue, setTabValue] = useState(1);
	const classes = useStyles();
	const [disabledUser, setdisabledUser] = useState(false);
	const { user } = useSelector((state) => state.auth);
	const systemLevelRole = user?.organos[0].nombrePerfil.toUpperCase();
	const [disableForm, setDisableForm] = useState(false);
	const [disableOrgans, setDisableOrgans] = useState(true);
	const [editForm, setEditForm] = useState(false);
	const [assignOrgans, setAssignOrgans] = useState(false);
	const isDev = process.env.REACT_APP_ENVIRONMENT === 'DEV';
	const canAssignOrgans = [
		'ADMINISTRADOR GENERAL',
		'RESPONSABLE DE ORGANO COLEGIADO',
		'RESPONSABLE DE SEGUIMIENTO',
		'RESPONSABLE DE NEGOCIO',
	];

	function clearForm() {
		let idUser = userResp.id;
		if (id) {
			tabValue === 1
				? setUser({ ...defaultUser, id: idUser, id_perfil: 6 })
				: setUser({ ...defaultUser, id: idUser });
		} else setUser(defaultUser);
	}

	useEffect(() => {
		if (
			systemLevelRole !== 'ADMINISTRADOR GENERAL' &&
			systemLevelRole !== 'OPERADOR DE SEGURIDAD'
		) {
			setDisableForm(true);
			setdisabledUser(true);
		}

		if (!id)
			if (tabValue === 1) {
				userResp.id_perfil = 6;
			}

		if (id) {
			if (systemLevelRole !== 'OPERADOR DE SEGURIDAD') setAssignOrgans(true);
			if (canAssignOrgans.includes(systemLevelRole) === true) {
				setDisableOrgans(false);
			}

			usersAPI
				.get(id)
				.then((res) => {
					let data = { ...res };

					if (data.correos.length > 0) {
						data.correos.forEach((item) => {
							if (item.principal === '1')
								data = {
									...data,
									correo: item.correo,
								};
							else if (item.principal === '0' && data.email1 === undefined)
								data = {
									...data,
									email1: item.correo,
								};
							else if (item.principal === '0' && data.email1 !== undefined)
								data = {
									...data,
									email2: item.correo,
								};
						});
					}
					let organsItems = [];
					if (data.organos.length > 0) {
						data.organos.forEach((item) => {
							organsItems.push({
								value: item.organoId,
								text: item.nombre || '',
								cargo: item.cargo || '',
							});
						});
					} else if (member.member) {
						organsItems = [
							{
								value: '',
								text: '',
								cargo: '',
							},
						];
					}
					let dataOrgans = {
						organs: organsItems,
					};
					setIdOrgans(
						dataOrgans.organs.map((item) => ({
							organoId: item.value,
							cargo: item.cargo || '',
						}))
					);
					setMemberOriginal(data.miembro);
					setMember({ member: data.miembro });
					setUser(data);
					setAddOrgans(dataOrgans);
					setEditForm(true);
					setTabValue(res.tipo === 'INT' || res.tipo === 'SEG' ? 2 : 1);
				})
				.catch((e) => notice('Error al cargar el usuario'));
		} else {
			setUser(defaultUser);
		}
	}, [id]);
	const handleChange = ({ target }, type, index) => {
		const { name, value } = target;
		if (name === 'miembro') {
			setMember({ member: target.value });
			setUser({ ...userResp, [name]: value });
		}
		if (type === 'tree') {
			const updatedOrgans = [...addOrgans?.organs];
			updatedOrgans[index] = {
				value: value,
				text: flagOrgans.find((item) => item.value === value).text,
			};
			setAddOrgans({
				...addOrgans,
				organs: updatedOrgans,
			});
			onSelecOrgans(updatedOrgans);
		} else if (type === 'cargo') {
			const updatedOrgans = [...addOrgans?.organs];
			updatedOrgans[index] = {
				...updatedOrgans[index],
				cargo: value,
			};
			setAddOrgans({
				...addOrgans,
				organs: updatedOrgans,
			});
			onSelecOrgans(updatedOrgans);
		} else {
			setUser({ ...userResp, [name]: value });
			if (name === 'organs') {
				onSelecOrgans(value);
				setAddOrgans({ ...addOrgans, [name]: value });
			}
		}
	};
	const onSelecOrgans = (organ) => {
		let arrayOrgans = [];
		if (!member.member) {
			organ.forEach((item) => {
				arrayOrgans.push({ organoId: item.value });
			});
		} else {
			organ.forEach((item) => {
				arrayOrgans.push({ organoId: item.value, cargo: item.cargo || '' });
			});
		}
		setIdOrgans(arrayOrgans);
	};

	const handleAddOrgan = () => {
		setAddOrgans({
			...addOrgans,
			organs: [...addOrgans.organs, { value: '', text: '' }],
		});
	};

	const onDelete = (value) => {
		const updatedOrgans = addOrgans.organs.filter((item) => item.value !== value);
		setIdOrgans(
			updatedOrgans.map((item) => ({ organoId: item.value, cargo: item.cargo }))
		);
		setAddOrgans({
			...addOrgans,
			organs: updatedOrgans,
		});
	};

	const onreturn = () => window.history.back();

	const createData = (isEdit) => {
		if (tabValue === 1) {
			if (!userResp.correo) {
				return notice('El correo electronico principal es requerido', 'warning');
			}
		}

		if (tabValue === 2) {
			if (!userResp.correo) {
				return notice(
					'El correo electronico es requerido, favor de actualizar sus datos en directorio activo, contacte a un administrador.',
					'warning'
				);
			}
		}

		if (userResp.id_perfil === null) {
			return notice(
				'El campo perfil es requerido, favor de seleccionar un perfil',
				'warning'
			);
		}

		const emails = [];
		if (userResp.correo) {
			let dataEmail = { correo: userResp.correo, principal: 1 };
			if (isEdit) {
				if (userResp.correos.length >= 1) {
					dataEmail = {
						...dataEmail,
						id: userResp.correos[0]?.id,
					};
				}
			}
			emails.push({ ...dataEmail });
		}

		if (userResp.email1) {
			let dataEmail = { correo: userResp.email1, principal: 0 };
			if (isEdit) {
				if (userResp.correos.length >= 2) {
					dataEmail = {
						...dataEmail,
						id: userResp.correos[1]?.id,
					};
				}
			}
			emails.push({ ...dataEmail });
		}
		if (userResp.email2) {
			let dataEmail = { correo: userResp.email2, principal: 0 };
			if (isEdit) {
				if (userResp.correos.length >= 3) {
					dataEmail = {
						...dataEmail,
						id: userResp.correos[2]?.id,
					};
				}
			}
			emails.push({ ...dataEmail });
		}
		let userFlag = {
			...userResp,
			cargo: member.member ? null : userResp.cargo,
			tipo: tabValue === 1 ? 'EXT' : 'INT',
			correos: [...emails],
		};
		delete userFlag.correo;
		delete userFlag.email1;
		delete userFlag.email2;
		delete userFlag.fechaCreacion;
		delete userFlag.fechaUltimoAcceso;
		if (isEdit) {
			const id = userFlag.id;
			delete userFlag.id;
			delete userFlag.usuario;
			delete userFlag.estatus;
			delete userFlag.organos;

			usersAPI
				.put(id, { ...userFlag })
				.then((res) => {
					//MOSTRAR MENSAJES DE ERROR EN PRODUCCION
					if (res.codigo === 'SAOC-400')
						notice(JSON.parse(JSON.stringify(res.mensaje)));
					else {
						notice('Usuario actualizado con éxito', 'success');
					}
				})
				.catch((e) => {
					if (isDev) {
						if (e.response.data.mensaje === undefined) {
							notice('Ha ocurrido un error con su petición');
						} else
							notice(
								JSON.parse(JSON.stringify(e.response.data.mensaje)),
								'warning'
							);
					} else notice('Ha ocurrido un error con su petición');
				});
		} else {
			usersAPI
				.post({ ...userFlag })
				.then((res) => {
					//MOSTRAR MENSAJES DE ERROR EN PRODUCCION
					if (res.codigo === 'SAOC-400')
						notice(JSON.parse(JSON.stringify(res.mensaje)));
					else {
						clearForm();
						notice('Usuario creado con éxito', 'success');
					}
				})
				.catch((e) => {
					if (isDev) {
						if (e.response.data.mensaje === undefined) {
							notice('Ha ocurrido un error con su petición');
						} else
							notice(
								JSON.parse(JSON.stringify(e.response.data.mensaje)),
								'warning'
							);
					} else notice('Ha ocurrido un error con su petición');
				});
		}
	};

	const onAssingOrgans = () => {
		let body = {
			id: Number(id),
			organos: idOrgans,
		};
		if (userResp.miembro && body.organos.length === 0) {
			notice('No se deben dejar campos vacios en órgano y cargo', 'warning');
			return;
		}
		if (
			userResp.miembro &&
			body.organos.length !== 0 &&
			body.organos.some((item) => item.cargo === '')
		) {
			notice('Es necesario asignar un cargo a cada uno de los órganos', 'warning');
			return;
		}
		if (memberOriginal !== member.member) {
			const emails = [];
			if (userResp.correo) {
				let dataEmail = { correo: userResp.correo, principal: 1 };

				if (userResp.correos.length >= 1) {
					dataEmail = {
						...dataEmail,
						id: userResp.correos[0]?.id,
					};
				}

				emails.push({ ...dataEmail });
			}

			if (userResp.email1) {
				let dataEmail = { correo: userResp.email1, principal: 0 };

				if (userResp.correos.length >= 2) {
					dataEmail = {
						...dataEmail,
						id: userResp.correos[1]?.id,
					};
				}

				emails.push({ ...dataEmail });
			}
			if (userResp.email2) {
				let dataEmail = { correo: userResp.email2, principal: 0 };

				if (userResp.correos.length >= 3) {
					dataEmail = {
						...dataEmail,
						id: userResp.correos[2]?.id,
					};
				}

				emails.push({ ...dataEmail });
			}
			if (userResp.miembro) userResp.cargo = '';

			let userFlag = {
				...userResp,
				tipo: tabValue === 1 ? 'EXT' : 'INT',
				correos: [...emails],
			};
			delete userFlag.correo;
			delete userFlag.email1;
			delete userFlag.email2;
			delete userFlag.fechaCreacion;
			delete userFlag.fechaUltimoAcceso;
			const id = userFlag.id;
			delete userFlag.id;
			delete userFlag.usuario;
			delete userFlag.estatus;
			delete userFlag.organos;

			usersAPI
				.put(id, { ...userFlag })
				.then((res) => {
					//MOSTRAR MENSAJES DE ERROR EN PRODUCCION
					if (res.codigo === 'SAOC-400')
						notice(JSON.parse(JSON.stringify(res.mensaje)));
					else {
						notice('Usuario actualizado con éxito', 'success');
					}
				})
				.catch((e) => {
					if (isDev) {
						if (e.response.data.mensaje === undefined) {
							notice('Ha ocurrido un error con su petición');
						} else
							notice(
								JSON.parse(JSON.stringify(e.response.data.mensaje)),
								'warning'
							);
					} else notice('Ha ocurrido un error con su petición');
				});
		}

		usersAPI
			.postAssignOrgans(body)
			.then((res) => {
				notice('Órganos asignados con exito', 'success');
			})
			.catch((e) => notice('Ha ocurrido un error con su petición'));
	};

	const handleChangeTab = (newValue) => {
		if (newValue === 2) {
			userResp.id_perfil = null;
		} else if (newValue === 1) userResp.id_perfil = 6;

		setTabValue(newValue);
		userResp.usuario = '';
		userResp.nombre = '';
		userResp.apellidoPaterno = '';
		userResp.apellidoMaterno = '';
		userResp.domicilio = '';
		userResp.telefono = '';
		userResp.sector = '';
		userResp.cargo = '';
		userResp.oficio = '';
		userResp.tipo = '';
		userResp.email1 = '';
		userResp.email2 = '';
		userResp.correo = '';
		userResp.institucionId = null;
		userResp.correos = [];
	};
	// const onHandleMember = ({ target }) => {
	// 	setMember({ member: target.value });
	// 	setUser({ ...userResp, miembro: target.value });
	// };

	useEffect(() => {
		if (member.member && addOrgans.organs.length === 0) {
			setAddOrgans({
				...addOrgans,
				organs: [{ value: '', text: '' }],
			});
		}
	}, [member.member]);

	return (
		<>
			{!id && (
				<AntTabs
					value={tabValue}
					options={userTypeTabs}
					onChange={handleChangeTab}
				/>
			)}
			<PageLayout
				title={
					perfil !== undefined
						? 'Mi Perfil'
						: tabValue === 1
						? 'Consejero'
						: 'Subdirector/Enlace'
				}
			>
				{tabValue === 1 && (
					<AdviserUserTab
						form={userResp}
						handleChange={handleChange}
						disableForm={disableForm}
						myProfile={perfil !== undefined ? true : false}
						isEdit={editForm}
						addOrgans={addOrgans}
						disableOrgan={disableOrgans}
						assignOrgans={assignOrgans}
						member={member}
						memberOriginal={memberOriginal}
						//onHandleMember={onHandleMember}
						handleAddOrgan={handleAddOrgan}
						onDelete={onDelete}
						setFlagOrgans={setFlagOrgans}
					/>
				)}
				{tabValue === 2 && (
					<LinkUserTab
						form={userResp}
						handleChange={handleChange}
						disableUser={disabledUser}
						disableForm={disableForm}
						myProfile={perfil !== undefined ? true : false}
						addOrgans={addOrgans}
						disableOrgan={disableOrgans}
						assignOrgans={assignOrgans}
						member={member}
						memberOriginal={memberOriginal}
						//onHandleMember={onHandleMember}
						handleAddOrgan={handleAddOrgan}
						onDelete={onDelete}
						setFlagOrgans={setFlagOrgans}
					/>
				)}
				<Grid className={classes.containerButtons} container spacing={2}>
					<Grid className={classes.subContainerButtons} item md={12}>
						{buttonsUser(
							() => createData(id ? true : false),
							clearForm,
							onreturn,
							disableForm,
							perfil !== undefined ? true : false,
							tabValue === 2 ? true : false, //validar que sea un usuario interno
							id ? false : true,
							() => onAssingOrgans(),
							disableOrgans //validacion para ocultar boton de asignar organos
						).map((button) => (
							<CustomButton
								key={button.title}
								mainText={button.title}
								color={button.color}
								onClick={button.onClick}
								disabled={button.disabled}
								className={button.className}
								style={{ width: 150 }}
							/>
						))}
					</Grid>
				</Grid>
			</PageLayout>
		</>
	);
};

export default NewUser;
